import Vue from "vue";
import recommends from "./recommends.vue";

export default function (entryId, data) {

	const entry = document.getElementById(entryId);

	if (!entry || !data) {
		return;
	}

	const el = document.createElement("div");

	entry.appendChild(el);

	new Vue({
		el: el,
		components: { recommends },
		render: createElement => createElement("recommends", { props: data })
	});
};
